var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          ref: "badge",
          class: ["badge", ..._vm.variantClassList, ..._vm.stateClassList]
        },
        [
          _vm.variant !== "rectangle"
            ? _c("span", { staticClass: "badge__pill" }, [
                _vm._v(" " + _vm._s(_vm.text) + " ")
              ])
            : _vm._e(),
          _vm.iconVisible
            ? _c(
                "span",
                {
                  ref: "rectanglePill",
                  staticClass: "badge__rectangle-pill",
                  attrs: { tabindex: "0" },
                  on: {
                    mouseover: _vm.onMouseEnter,
                    mouseout: _vm.onMouseLeave,
                    focus: _vm.onFocus,
                    blur: _vm.onBlur
                  }
                },
                [_c("i", { staticClass: "icon icon-warning" })]
              )
            : _vm._e(),
          _vm.rectangleVisible
            ? _c(
                "span",
                { staticClass: "badge__rectangle" },
                [
                  _vm._t("default", function() {
                    return [
                      _c("span", { staticClass: "badge__rectangle-text" }, [
                        _vm._v(" " + _vm._s(_vm.text) + " ")
                      ])
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _c(
            "Tooltip",
            {
              attrs: {
                placement: "top",
                visible: _vm.displayTooltip || _vm.pillOnFocus,
                trackedRefName: "rectanglePill",
                positionStrategy: "fixed",
                offset: [0, 8],
                state: _vm.state
              }
            },
            [_vm._v(" " + _vm._s(this.slotContent) + " ")]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }